import { render, staticRenderFns } from "./RespostaBase.vue?vue&type=template&id=5a78a7fe"
import script from "./RespostaBase.vue?vue&type=script&lang=js"
export * from "./RespostaBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports